export default {
  catalogInfo: {},
  modelos: [],
  modelo: {},
  codigosModelos: [],
  productos: [],
  modelInfo: null,
  waitExtranet: null,
  loading: 0,
  actualAlert: null,
  colorFondo: null,
  cancelationExtranetToken: null
};
